import { kernelService } from '../../services';

// initial state
const state = {
    countries: [],
    aissen: [],
};

// getters
const getters = {};

// actions
const actions = {
    ping ({ dispatch }) {
        return kernelService
            .ping()
            .then((response) => response)
            .catch((error) => {
                dispatch('alert/error', { error }, { root: true });

                return error;
            });
    },

    countries ({ dispatch, commit }) {
        return kernelService
            .getCountries()
            .then((countries) => {
                commit('setCountries', countries);

                return countries;
            })
            .catch((error) => {
                dispatch('alert/error', { error }, { root: true });

                return error;
            });
    },

    aissen ({ dispatch, commit }) {
        return kernelService
            .getAissen()
            .then((aissen) => {
                commit('setAissen', aissen);

                return aissen;
            })
            .catch((error) => {
                dispatch('alert/error', { error }, { root: true });

                return error;
            });
    },
};

// mutations
const mutations = {
    setCountries (state, countries) {
        state.countries = countries;
    },
    setAissen (state, aissen) {
        state.aissen = aissen;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
